import { FETCH_PROD_HOST } from '../../../common/constants/requestConfig';
import { ResponseError } from '../../../common/errors/responseError';
import { IApplicationContext } from '../../../common/types/applicationContext';

interface ISubscribeProps {
  email: string;
  source: string;
}

export async function fetchSubscribe(
  { httpApi, logger }: IApplicationContext,
  { email, source }: ISubscribeProps,
): Promise<{ statusCode: number; message: string }> {
  try {
    const { responseBody, responseStatusCode } = await httpApi.httpRequest({
      uri: { host: FETCH_PROD_HOST, path: '/api/agencies-rating/v1/add-contact' },
      method: 'POST',
      withCredentials: true,
      headers: [['Content-Type', 'application/x-www-form-urlencoded']],
      body: JSON.stringify({ email, source }),
    });

    if (responseStatusCode !== 200) {
      throw new ResponseError({
        domain: 'info',
        message: JSON.parse(responseBody),
      });
    }

    return JSON.parse(responseBody);
  } catch (ex) {
    logger.error(ex);

    return { message: 'Произошла ошибка, попробуйте позднее', statusCode: 500 };
  }
}
